// TODO: Define enum for delivery methods, also used in delivery-picker.js

class MOQChecker extends HTMLElement {
  constructor() {
    super();

    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.cartInformation = document.querySelector("[data-cart-information]");

    // Needs translations
    this.freeShippingSelectedNonEligibleFreeItemMessage = this.getAttribute("data-free-shipping-selected-non-eligible-free-item-added-to-cart");
    this.phsSelectedItemAddedToCartMessage = this.getAttribute("data-phs-selected-item-added-to-cart-but-order-moq-not-fulfilled");
    this.changedToFreeShippingNonEligibleItemsMessage = this.getAttribute("data-changed-to-free-shipping-non-eligible-items-in-cart");
    this.changedToPhsOrderMoqNotFulfilledMessage = this.getAttribute("data-changed-to-phs-order-moq-not-fulfilled");
    this.cartErrorNonEligibleFreeShippingMessage = this.getAttribute("data-cart-error-non-eligible-free-shipping-items-in-cart");
    this.cartErrorOrderMoqNotFulfilledMessage = this.getAttribute("data-cart-error-order-moq-not-fulfilled");

    this.checkoutButton = document.querySelector(".button--checkeout");

    this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
  }

  connectedCallback() {
    document.addEventListener("cart-updated-global", this.onCartUpdated.bind(this));
    document.addEventListener("item-added-global", this.onItemAdded.bind(this));
    document.addEventListener("delivery-method-changed", this.onDeliveryMethodChanged.bind(this));
  }

  onDeliveryMethodChanged(e) {
    const deliveryMethod = e.detail.newDeliveryMethod;
    const changedFromCart = e.detail.changedFromCart;
    let showPopup = true;

    if(!deliveryMethod) return;
    if(changedFromCart) showPopup = false;

    this.deliveryMethod = deliveryMethod;

    this.checkRules(deliveryMethod, showPopup, false);
    if(deliveryMethod == 'pickup') this.onStorePickupSelected();
  }

  onCartUpdated() {
    if(!this.deliveryMethod) return;
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(this.deliveryMethod, false, false);
  }

  onItemAdded() {
    if(!this.deliveryMethod) return;
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(this.deliveryMethod, false, true);
  }

  onStorePickupSelected() {
    this.hideCartErrors();
    this.enableCheckout();
  }

  checkRules(deliveryMethod, showPopup, itemAdded) {
    // console.log("checking rules...");
    // console.log("Has items in cart: ", this.hasItemsInCart());
    // console.log("Is order MOQ eligible: ", this.isOrderMOQEligible());
    // console.log("Has non free shipping eligible items: ", this.hasNonFreeShippingEligibleItems());

    if(deliveryMethod == "pickup") return;

    this.cartErrors.innerHTML = "";
    this.enableCheckout();

    if(deliveryMethod === "phs") {
      const { eligible, items} = this.isOrderMOQEligible();
      // we've just added first item
      if(this.cartItemsCount() == 1 && itemAdded && !eligible) {
        this.showPopup(this.phsSelectedItemAddedToCartMessage);
        return;
      }

      if(this.hasItemsInCart() && !eligible) {
        if(showPopup) this.showPopup(this.changedToPhsOrderMoqNotFulfilledMessage);
        this.disableCheckout();
        this.renderCartErrors("moq-not-fulfilled", items);
      }
    }
    else {
      const { eligible, items} = this.hasNonFreeShippingEligibleItems();
      if(this.cartItemsCount() == 1 && itemAdded && !eligible) {
        this.showPopup(this.freeShippingSelectedNonEligibleFreeItemMessage);
        return;
      }

      if(this.hasItemsInCart() && !eligible) {
        if(showPopup) this.showPopup(this.changedToFreeShippingNonEligibleItemsMessage);
        this.disableCheckout();
        this.renderCartErrors("free-shipping-non-eligible", items);
      }
    }
  }

  renderCartErrors(type, items) {
    let cartError = "";
    switch(type) {
      case "moq-not-fulfilled":
        cartError = this.cartErrorOrderMoqNotFulfilledMessage;
        if (items && items.length > 0) {
          cartError += "<ul>";
          items.forEach(item => {
            cartError += `<li>${item.title} - MOQ: ${item.moq}</li>`;
          });
          cartError += "</ul>";
        }
        break;
      case "free-shipping-non-eligible":
        cartError = this.cartErrorNonEligibleFreeShippingMessage;
        if (items && items.length > 0) {
          cartError += "<ul>";
          items.forEach(item => {
            cartError += `<li>${item}</li>`;
          });
          cartError += "</ul>";
        }
        break
    }

    this.cartErrors.innerHTML = cartError;
    this.showCartErrors();
  }

  hideCartErrors() {
    this.cartErrors.classList.add("hidden");
  }

  showCartErrors() {
    this.cartErrors.classList.remove("hidden");
  }

  // checking if one of the items fulfills MOQ
  hasMOQEligibleItem() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo || cartInfo.cart.items.length === 0 ) return;

    let hasMOQEligibleItem = false;
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
        if(item.qty >=  item.moq) {
            hasMOQEligibleItem = true;
        }
    }

    return hasMOQEligibleItem;
  }

  // checks if order MOQ is fulfilled, different than checking individual items since multiple items can fulfill one MOQ
  isOrderMOQEligible() {
    const cartInfo = this.getCartInformation();
    if (!cartInfo || cartInfo.cart.items.length === 0) return false;
  
    let collectionQuantities = {};
    let nonEligibleItems = [];
    // one eligible item is enough for order to be eligible
    let hasEligibleItem = false;

    for (let i = 0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      const collectionId = item.moqCollectionId;
      const collectionMOQ = item.moqCollection;
      const itemMOQ = item.moq;
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId).length;

      if(countOfItemsFromSameCollection === 1) {
        if (item.qty < itemMOQ) {
          nonEligibleItems.push({ title: item.title, moq: itemMOQ });
        }
        else {
          hasEligibleItem = true;
        }
      }
  
      if (!collectionQuantities[collectionId]) {
        collectionQuantities[collectionId] = 0;
      }
      collectionQuantities[collectionId] += item.qty;
    }
  
    for (let collectionId in collectionQuantities) {
      const itemInCollection = cartInfo.cart.items.find(item => item.moqCollectionId === collectionId);
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId).length;

      if(countOfItemsFromSameCollection > 1) {
        if (collectionQuantities[collectionId] < itemInCollection.moqCollection) {
          nonEligibleItems.push({ title: itemInCollection.moqNotFulfilledTitle, moq: itemInCollection.moqCollection });
        }
        else {
          hasEligibleItem = true;
        }
      }
    }

    return { eligible: hasEligibleItem, items: nonEligibleItems };
  }

  hasNonFreeShippingEligibleItems() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo || cartInfo.cart.items.length ===0 ) return;

    let nonFreeShippingItems = [];
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      if(!item.eligibleForFreeShipping) {
        nonFreeShippingItems.push(item.title); 
      }
    }

    return { eligible: nonFreeShippingItems.length === 0, items: nonFreeShippingItems };
  }

  enableCheckout() {
    this.checkoutButton.disabled = false;
  }
  
  disableCheckout() {
    this.checkoutButton.disabled = true;
  }

  getCartScript() {
    this.cartInformation = document.querySelector("[data-cart-information]");
  }

  getCartInformation() {
    this.cartInformation = document.querySelector("[data-cart-information]");

    if (!this.cartInformation) return;
    const cartData = JSON.parse(this.cartInformation.textContent);

    return cartData;
  }

  hasItemsInCart() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.items.length > 0;
  }
  
  cartItemsCount() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.items.length;
  }

  getItemMOQNotFulfilledMessage(moq, title) {
    return `${moq} ${title}`;
  }

  showPopup(message) {
    const moqPopup = document.querySelector(".moq-popup-wrapper");
    const mopText = document.querySelector(".moq-popup__text");
    mopText.innerText = message;

    const mopActionItems = document.querySelector(".moq-popup__action-items");
    mopActionItems.innerHTML = "";
    const okButton = document.createElement("button");
    okButton.classList =
      "button button--solid button--regular button--regular-mobile";
    okButton.innerText = "OK";
    okButton.addEventListener("click", () => {
      moqPopup.classList.remove("show");
    });

    mopActionItems.appendChild(okButton);

    moqPopup.classList.add("show");
  }
}

customElements.define("moq-checker", MOQChecker);



// TODO: Define enum for delivery methods, also used in delivery-picker.js

class MOQCheckerV2 extends HTMLElement {
  constructor() {
    super();

    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.cartInformation = document.querySelector("[data-cart-information]");

    this.freeShippingSelectedNonEligibleFreeItemMessage = this.getAttribute("data-free-shipping-selected-non-eligible-free-item-added-to-cart");
    this.phsSelectedItemAddedToCartMessage = this.getAttribute("data-phs-selected-item-added-to-cart-but-order-moq-not-fulfilled");
    this.changedToFreeShippingNonEligibleItemsMessage = this.getAttribute("data-changed-to-free-shipping-non-eligible-items-in-cart");
    this.changedToPhsOrderMoqNotFulfilledMessage = this.getAttribute("data-changed-to-phs-order-moq-not-fulfilled");
    this.cartErrorNonEligibleFreeShippingMessage = this.getAttribute("data-cart-error-non-eligible-free-shipping-items-in-cart");
    this.cartErrorOrderMoqNotFulfilledMessage = this.getAttribute("data-cart-error-order-moq-not-fulfilled");
    
    this.deliveryMethodChangeItemsInCart = this.getAttribute("data-delivery-method-change-items-in-cart");
    this.moqNotFulfilledLargeBales = this.getAttribute("data-moq-not-fulfilled-large-bales");
    this.orderLimitNotFulfilled = this.getAttribute("data-order-limit-not-fulfilled");

    this.checkoutButton = document.querySelector(".button--checkeout");

    this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
    this.previousDeliveryMethod = this.deliveryMethod;
  }

  connectedCallback() {
    document.addEventListener("cart-updated-global", this.onCartUpdated.bind(this));
    document.addEventListener("item-added-global", this.onItemAdded.bind(this));
    document.addEventListener("delivery-method-changed", this.onDeliveryMethodChanged.bind(this));
  }

  onDeliveryMethodChanged(e) {
    const deliveryMethod = e.detail.newDeliveryMethod;
    const changedFromCart = e.detail.changedFromCart;
    let showPopup = true;

    if(!deliveryMethod) return;
    if(changedFromCart) showPopup = false;

    this.deliveryMethod = deliveryMethod;

    this.checkRules(deliveryMethod, showPopup, false);
    if(deliveryMethod == 'pickup') this.onStorePickupSelected();
  }

  onCartUpdated() {
    if(!this.deliveryMethod) return;
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(this.deliveryMethod, false, false);
  }

  onItemAdded() {
    if(!this.deliveryMethod) return;
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(this.deliveryMethod, false, true);
  }

  onStorePickupSelected() {
    this.hideCartErrors();
    this.enableCheckout();
  }

  checkRules(deliveryMethod, showPopup, itemAdded) {
    // console.log("checking rules...");
    // console.log("Has items in cart: ", this.hasItemsInCart());
    // console.log("Is order MOQ eligible: ", this.isOrderMOQEligible());
    // console.log("Has non free shipping eligible items: ", this.hasNonFreeShippingEligibleItems());

    if(deliveryMethod == "pickup") return;

    this.cartErrors.innerHTML = "";
    this.enableCheckout();

    if(deliveryMethod === "phs") {
      const { eligible, items} = this.isOrderMOQEligible();
      const { eligible: freeShippingEligible, items: freeShippingEligibleItems} = this.hasNonFreeShippingEligibleItems();
      // we've just added first item
      // if the item is not free shipping eligible, then there is MOQ
      if(this.cartItemsCount() == 1 && itemAdded && !eligible && !freeShippingEligible) {
        this.showPopup(this.phsSelectedItemAddedToCartMessage);
        return;
      }

      if(this.hasItemsInCart() && !eligible && !freeShippingEligible) {
        if(showPopup) this.showPopup(this.changedToPhsOrderMoqNotFulfilledMessage);
        this.disableCheckout();
        this.renderCartErrors("moq-not-fulfilled", items);
      }

      if(this.hasItemsInCart() && this.cartTotal() < 25000) {
        this.disableCheckout();
        this.renderCartErrors("order-limit-not-reached", items);
      }
    }
    else {
      const { eligible, items} = this.hasNonFreeShippingEligibleItems();
      if(this.cartItemsCount() == 1 && itemAdded && !eligible) {
        this.showPopup(this.freeShippingSelectedNonEligibleFreeItemMessage);
        return;
      }

      if(this.hasItemsInCart() && !eligible) {
        if(showPopup) this.showPopup(this.changedToFreeShippingNonEligibleItemsMessage);
        this.disableCheckout();
        this.renderCartErrors("free-shipping-non-eligible", items);
      }
    }
  }

  renderCartErrors(type, items) {
    let cartError = "";
    switch(type) {
      case "order-limit-not-reached":
        cartError = this.orderLimitNotFulfilled;
        break;
      case "moq-not-fulfilled":
        cartError = this.moqNotFulfilledLargeBales;
        break;
      case "free-shipping-non-eligible":
        cartError = this.cartErrorNonEligibleFreeShippingMessage;
        if (items && items.length > 0) {
          cartError += "<ul>";
          items.forEach(item => {
            cartError += `<li>${item}</li>`;
          });
          cartError += "</ul>";
        }
        break
    }

    this.cartErrors.innerHTML = cartError;
    this.showCartErrors();
  }

  hideCartErrors() {
    this.cartErrors.classList.add("hidden");
  }

  showCartErrors() {
    this.cartErrors.classList.remove("hidden");
  }

  // checking if one of the items fulfills MOQ
  hasMOQEligibleItem() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo || cartInfo.cart.items.length === 0 ) return;

    let hasMOQEligibleItem = false;
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
        if(item.qty >=  item.moq) {
            hasMOQEligibleItem = true;
        }
    }

    return hasMOQEligibleItem;
  }

  // checks if order MOQ is fulfilled, different than checking individual items since multiple items can fulfill one MOQ
  isOrderMOQEligible() {
    const cartInfo = this.getCartInformation();
    if (!cartInfo || cartInfo.cart.items.length === 0) return false;
  
    let collectionQuantities = {};
    let nonEligibleItems = [];
    // one eligible item is enough for order to be eligible
    let hasEligibleItem = false;

    for (let i = 0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      const collectionId = item.moqCollectionId;
      const collectionMOQ = item.moqCollection;
      const itemMOQ = item.moq;
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId).length;

      if(countOfItemsFromSameCollection === 1) {
        if (item.qty < itemMOQ) {
          nonEligibleItems.push({ title: item.title, moq: itemMOQ });
        }
        else {
          hasEligibleItem = true;
        }
      }
  
      if (!collectionQuantities[collectionId]) {
        collectionQuantities[collectionId] = 0;
      }
      collectionQuantities[collectionId] += item.qty;
    }
  
    for (let collectionId in collectionQuantities) {
      const itemInCollection = cartInfo.cart.items.find(item => item.moqCollectionId === collectionId);
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId).length;

      if(countOfItemsFromSameCollection > 1) {
        if (collectionQuantities[collectionId] < itemInCollection.moqCollection) {
          nonEligibleItems.push({ title: itemInCollection.moqNotFulfilledTitle, moq: itemInCollection.moqCollection });
        }
        else {
          hasEligibleItem = true;
        }
      }
    }

    return { eligible: hasEligibleItem, items: nonEligibleItems };
  }

  hasNonFreeShippingEligibleItems() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo || cartInfo.cart.items.length ===0 ) return;

    let nonFreeShippingItems = [];
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      if(!item.eligibleForFreeShipping) {
        nonFreeShippingItems.push(item.title); 
      }
    }

    return { eligible: nonFreeShippingItems.length === 0, items: nonFreeShippingItems };
  }

  enableCheckout() {
    this.checkoutButton.disabled = false;
  }
  
  disableCheckout() {
    this.checkoutButton.disabled = true;
  }

  getCartScript() {
    this.cartInformation = document.querySelector("[data-cart-information]");
  }

  getCartInformation() {
    this.cartInformation = document.querySelector("[data-cart-information]");

    if (!this.cartInformation) return;
    const cartData = JSON.parse(this.cartInformation.textContent);

    return cartData;
  }

  hasItemsInCart() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.items.length > 0;
  }
  
  cartTotal() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.total;
  }

  cartItemsCount() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.items.length;
  }

  getItemMOQNotFulfilledMessage(moq, title) {
    return `${moq} ${title}`;
  }

  showPopup(message) {
    const moqPopup = document.querySelector(".moq-popup-wrapper");
    const mopText = document.querySelector(".moq-popup__text");
    mopText.innerText = message;

    const mopActionItems = document.querySelector(".moq-popup__action-items");
    mopActionItems.innerHTML = "";
    const okButton = document.createElement("button");
    okButton.classList =
      "button button--solid button--regular button--regular-mobile";
    okButton.innerText = "OK";
    okButton.addEventListener("click", () => {
      moqPopup.classList.remove("show");
    });

    mopActionItems.appendChild(okButton);

    moqPopup.classList.add("show");
  }
}

customElements.define("moq-checker-v2", MOQCheckerV2);



class MOQCheckerV3 extends HTMLElement {
  constructor() {
    super();

    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.cartInformation = document.querySelector("[data-cart-information]");

    this.freeShippingSelectedNonEligibleFreeItemMessage = this.getAttribute("data-free-shipping-selected-non-eligible-free-item-added-to-cart");
    this.phsSelectedItemAddedToCartMessage = this.getAttribute("data-phs-selected-item-added-to-cart-but-order-moq-not-fulfilled");
    this.changedToFreeShippingNonEligibleItemsMessage = this.getAttribute("data-changed-to-free-shipping-non-eligible-items-in-cart");
    this.changedToPhsOrderMoqNotFulfilledMessage = this.getAttribute("data-changed-to-phs-order-moq-not-fulfilled");
    this.cartErrorNonEligibleFreeShippingMessage = this.getAttribute("data-cart-error-non-eligible-free-shipping-items-in-cart");
    this.cartErrorOrderMoqNotFulfilledMessage = this.getAttribute("data-cart-error-order-moq-not-fulfilled");
    
    this.deliveryMethodChangeItemsInCart = this.getAttribute("data-delivery-method-change-items-in-cart");
    this.moqNotFulfilledLargeBales = this.getAttribute("data-moq-not-fulfilled-large-bales");
    this.orderLimitNotFulfilled = this.getAttribute("data-order-limit-not-fulfilled");

    this.checkoutButton = document.querySelector(".button--checkeout");

    this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
    this.previousDeliveryMethod = this.deliveryMethod;
  }

  connectedCallback() {
    document.addEventListener("cart-updated-global", this.onCartUpdated.bind(this));
    document.addEventListener("item-added-global", this.onItemAdded.bind(this));

    this.checkRules(false);
  }

  onCartUpdated() {
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(false);
  }

  onItemAdded() {
    this.cartErrors = document.querySelector("[data-moq-cart-errors]");
    this.checkoutButton = document.querySelector(".button--checkeout");

    this.checkRules(true);
  }

  cartPHSTotal() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;

    let totalMoqEligible = 0;
    let phsItems = [];
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      console.log(item);
        if(item.enforcePHSLimit) {
          totalMoqEligible += item.price;
          phsItems.push(item.title); 
        }
    }
  
    return { totalMoqEligible: totalMoqEligible, phsItems: phsItems };
  }


  checkRules(itemAdded) {
    console.log("checking rules...");
    console.log("Has items in cart: ", this.hasItemsInCart());
    console.log("Is order MOQ eligible: ", this.isOrderMOQEligible());
    console.log("Total: ", this.cartPHSTotal());

    this.cartErrors.innerHTML = "";
    this.enableCheckout();

    const { eligible, items} = this.isOrderMOQEligible();
    const { totalMoqEligible, phsItems} = this.cartPHSTotal();
    // we've just added first cartPHSTotal
    // if the item is not free shipping eligible, then there is MOQ

    if(this.hasItemsInCart() && items.length > 0) {
      this.disableCheckout();
      this.renderCartErrors("moq-not-fulfilled", items);
    }

    if(this.hasItemsInCart() && totalMoqEligible < 25000 && phsItems.length > 0) {
      this.disableCheckout();
      this.renderCartErrors("order-limit-not-reached", items);
    }
  }

  hasItemsInCart() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo) return;
    
    return cartInfo.cart.items.length > 0;
  }

  renderCartErrors(type, items) {
    let cartError = "";
    switch(type) {
      case "order-limit-not-reached":
        cartError = this.orderLimitNotFulfilled;
        break;
      case "moq-not-fulfilled":
        cartError = this.moqNotFulfilledLargeBales;
        break;
      case "free-shipping-non-eligible":
        cartError = this.cartErrorNonEligibleFreeShippingMessage;
        if (items && items.length > 0) {
          cartError += "<ul>";
          items.forEach(item => {
            cartError += `<li>${item}</li>`;
          });
          cartError += "</ul>";
        }
        break
    }

    this.cartErrors.innerHTML = cartError;
    this.showCartErrors();
  }

  hideCartErrors() {
    this.cartErrors.classList.add("hidden");
  }

  showCartErrors() {
    this.cartErrors.classList.remove("hidden");
  }

  // checking if one of the items fulfills MOQ
  hasMOQEligibleItem() {
    const cartInfo = this.getCartInformation();
    if(!cartInfo || cartInfo.cart.items.length === 0 ) return;

    let hasMOQEligibleItem = false;
    for(let i=0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
        if(item.qty >=  item.moq) {
            hasMOQEligibleItem = true;
        }
    }

    return hasMOQEligibleItem;
  }

  // checks if order MOQ is fulfilled, different than checking individual items since multiple items can fulfill one MOQ
  isOrderMOQEligible() {
    const cartInfo = this.getCartInformation();
    if (!cartInfo || cartInfo.cart.items.length === 0) return false;
  
    let collectionQuantities = {};
    let nonEligibleItems = [];
    // one eligible item is enough for order to be eligible
    let hasEligibleItem = false;

    for (let i = 0; i < cartInfo.cart.items.length; i++) {
      const item = cartInfo.cart.items[i];
      const collectionId = item.moqCollectionId;
      const collectionMOQ = item.moqCollection;
      const itemMOQ = item.moq;
      const enforceMOQ = item.enforceMOQ;
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId && item.enforceMOQ).length;

      if(countOfItemsFromSameCollection === 1) {
        if (item.qty < itemMOQ && enforceMOQ) {
          nonEligibleItems.push({ title: item.title, moq: itemMOQ });
        }
        else {
          hasEligibleItem = true;
        }
      }
  
      if (!collectionQuantities[collectionId]) {
        collectionQuantities[collectionId] = 0;
      }
      collectionQuantities[collectionId] += item.qty;
    }
  
    for (let collectionId in collectionQuantities) {
      const itemInCollection = cartInfo.cart.items.find(item => item.moqCollectionId === collectionId && item.enforceMOQ);
      const countOfItemsFromSameCollection = cartInfo.cart.items.filter(item => item.moqCollectionId === collectionId && item.enforceMOQ).length;

      if(countOfItemsFromSameCollection > 1) {
        if (collectionQuantities[collectionId] < itemInCollection.moqCollection) {
          nonEligibleItems.push({ title: itemInCollection.moqNotFulfilledTitle, moq: itemInCollection.moqCollection });
        }
        else {
          hasEligibleItem = true;
        }
      }
    }

    return { eligible: hasEligibleItem, items: nonEligibleItems };
  }

  enableCheckout() {
    this.checkoutButton.disabled = false;
  }
  
  disableCheckout() {
    this.checkoutButton.disabled = true;
  }

  getCartScript() {
    this.cartInformation = document.querySelector("[data-cart-information]");
  }

  getCartInformation() {
    this.cartInformation = document.querySelector("[data-cart-information]");

    if (!this.cartInformation) return;
    const cartData = JSON.parse(this.cartInformation.textContent);

    return cartData;
  }
}

customElements.define("moq-checker-v3", MOQCheckerV3);
